import axios from "axios";

const instance = axios.create({
    baseURL: 'https://econet.ecostore.it/spc/spcBack/api',
    // baseURL: 'https://econet-coll.ecostore.it/spc/spcBack/api',
    // baseURL: 'http://localhost:8989/api',
    headers: {
        'Content-Type':  'application/x-www-form-urlencoded; charset=UTF-8'
    }
});

export default instance;
